module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-60x60-d088face1d762c05cfdd7fa30fa8f509.png";